// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionCustomReviews_root__3NpWN","title":"SectionCustomReviews_title__3TX-T","reviews":"SectionCustomReviews_reviews__3HcUd"};